module.exports = __webpack_public_path__ + "static/media/cubes.361386c4.svg";